import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

import Logo from "Assets/Common/logo.png";

import UseServices from "Hooks/UseServices";

import Button from "Components/Global/Buttons";
import Loading from "Components/Global/Loading";

import * as S from "./styles";

/**
 * Página PÚBLICA do arquivo de projeto (hoje, o book de captação).
 *
 * O link chega pela APRESENTAÇÃO da seletiva — um .pptx que o patrocinador
 * baixa e pode repassar. Por isso não há login: a autorização é o token opaco
 * assinado em `?t=`, válido por 3 meses.
 */
const ProjectFile = () => {
  const { api } = UseServices();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("t");

  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);

  // O React 18 em dev monta duas vezes; sem o ref o arquivo seria solicitado
  // (e o download disparado) em duplicidade.
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;

    requested.current = true;

    if (!token) {
      setLoading(false);
      setResult({
        variant: "error",
        title: "Link inválido",
        message:
          "Este endereço está incompleto. Abra o link diretamente da apresentação que você recebeu.",
      });

      return;
    }

    const fetchFile = async () => {
      try {
        const { data } = await api.post("/projects/get-file-by-token", {
          token,
        });

        setResult({
          variant: "success",
          title: data?.file_name || "Arquivo disponível",
          message: "O download começa automaticamente.",
          project_name: data?.project_name,
          signed_url: data?.signed_url,
          file_name: data?.file_name,
        });

        // Dispara o download; o botão abaixo fica como alternativa, porque
        // alguns navegadores bloqueiam o redirecionamento automático.
        if (data?.signed_url) window.location.assign(data.signed_url);
      } catch (error) {
        // A mensagem do backend já é amigável (link inválido/expirado, arquivo
        // indisponível) — aqui ela É o conteúdo da tela, não um toast.
        setResult({
          variant: "error",
          title: "Não foi possível abrir o arquivo",
          message:
            error?.response?.data?.error ||
            "O link pode ter expirado. Solicite uma apresentação atualizada.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchFile();
    // eslint-disable-next-line
  }, [token]);

  return (
    <S.Wrapper>
      <S.Modal
        role="dialog"
        aria-modal="true"
        aria-labelledby="project-file-title"
      >
        <S.Logo src={Logo} alt="Sevenx" />

        {loading ? (
          <>
            <Loading />
            <S.Message>Preparando o arquivo...</S.Message>
          </>
        ) : (
          <>
            <S.Icon $variant={result?.variant}>
              {result?.variant === "error" ? "!" : "✓"}
            </S.Icon>

            <S.Title id="project-file-title">{result?.title}</S.Title>

            <S.Message>
              {result?.message}
              {result?.project_name ? (
                <>
                  <br />
                  Projeto: <S.ProjectName>{result.project_name}</S.ProjectName>
                </>
              ) : null}
            </S.Message>

            {result?.signed_url ? (
              <S.Actions>
                <Button
                  type="button"
                  text={`Baixar ${result.file_name || "arquivo"}`}
                  onClick={() => window.location.assign(result.signed_url)}
                />
              </S.Actions>
            ) : null}
          </>
        )}
      </S.Modal>
    </S.Wrapper>
  );
};

export default ProjectFile;
